import moment from 'moment/moment';
import { FormattedMessage } from 'react-intl';
import { getMemberKey, getMemberName } from '../AffordaHousehold/utils';
import { validateNoSpecialChars } from 'utils/validateNoSpecialChars';

export const BUTTON_GROUP_SX = {
  flexWrap: 'wrap',
  width: '100%',
  '& > button': {
    width: { xs: 'calc(100% - 4px)', sm: 'calc(50% - 4px)' },
  },
};

export const YES_NO_OPTIONS = [
  {
    label: <FormattedMessage id="app.yes" />,
    value: 'yes',
  },
  {
    label: <FormattedMessage id="app.no" />,
    value: 'no',
  },
];

export const GridProps = {
  xs: 12,
  sm: 6,
  md: 6,
};

export const SMALL_GRID_PROPS = {
  xs: 12,
  sm: 6,
};

export const LARGE_GRID_PROPS = {
  xs: 12,
  sm: 12,
};

export const FIELD_TEXT_REQUIRED = {
  variant: 'text',
  GridProps: {
    xs: 12,
  },
  rules: {
    required: true,
    validate: validateNoSpecialChars,
  },
};

export const FIELD_YES_NO = {
  variant: 'buttonGroup',
  rules: {
    required: true,
  },
  options: YES_NO_OPTIONS,
  direction: 'row',
  GridProps: {
    xs: 12,
  },
};

export const FIELD_AMOUNT = {
  variant: 'number',
  GridProps,
  rules: {
    max: 499999.99,
    min: 0,
    step: 0.01,
    required: true,
  },
  adornment: '$',
};

export const FIELD_DATE = {
  variant: 'date',
  GridProps: {
    xs: 6,
  },
};

export const FIELD_INTEREST_RATE = {
  variant: 'number',
  GridProps: {
    xs: 6,
  },
  rules: {
    max: 100.0,
    min: 0.0,
    step: 0.01,
  },
  adornment: '%',
};

export const FIELD_DATE_PAST = {
  ...FIELD_DATE,
  disableFuture: true,
  defaultCalendarMonth: moment(moment().year(), 'YYYY'),
  rules: {
    required: true,
    maxDate: moment().startOf('day'),
  },
};

export const COMMON_FIELD_NAMES = {
  memberId: 'memberId',
  accountType: 'accountType',
  amount: 'amount',
  feesToConvert: 'feesToConvert',
  feesToConvertCash: 'feesToConvertCash',
  interestRate: 'interestRate',
  marketValue: 'marketValue',
  type: 'type',
};

export const FIELD_MEMBER_SELECTED = {
  watchFields: [COMMON_FIELD_NAMES.memberId],
  hidden: ({ getValues }) => !getValues(COMMON_FIELD_NAMES.memberId)?.length,
};

export const FIELD_GROUP_BUTTONS = {
  variant: 'buttonGroup',
  direction: 'row',
  rules: {
    required: true,
  },
  GridProps: {
    xs: 12,
  },
  sx: BUTTON_GROUP_SX,
};

export const FIELD_MEMBERS = ({ members, disabledMembers }) =>
  (members?.length ?? 0) > 1 //
    ? [
        {
          name: COMMON_FIELD_NAMES.memberId,
          variant: 'buttonGroup',
          watchFields: [COMMON_FIELD_NAMES.memberId],
          rules: {
            required: true,
          },
          direction: 'row',
          GridProps: {
            xs: 12,
          },
          sx: BUTTON_GROUP_SX,
          options: members.map((member) => ({
            value: getMemberKey(member),
            label: getMemberName(member),
            disabled: disabledMembers?.includes(getMemberKey(member)),
          })),
        },
      ]
    : [];
